// extracted by mini-css-extract-plugin
export default {"latest_pickup":"latestPickup_latest_pickup__s24Z5","input_part":"latestPickup_input_part__JhHns","validation_message":"latestPickup_validation_message__yzW7J"};